export default __webpack_public_path__ + "static/media/Logo.b9fcd954.png";